/**
 * Cloud decision records shared by the simulation engine (which emits them) and
 * the frontend decision table (which renders them). Kept here so the two cannot
 * drift; `packages/backend-shared/.../decision.ts` re-exports them under its own
 * `Decision*` names.
 */

/** Direction a cloud security enforcement point evaluated traffic in. */
export type CloudSecurityDirection = 'inbound' | 'outbound';

/** Next-hop kind of a cloud route; what gives the route its type. */
export type CloudNextHopKind =
  | 'CLOUD_NETWORK'
  | 'DROP'
  | 'GATEWAY'
  | 'INSTANCE'
  | 'INTERNET'
  | 'INTERNET_GATEWAY'
  | 'IP_ADDRESS'
  | 'LOCAL'
  | 'NAT_GATEWAY'
  | 'NETWORK_INTERFACE'
  | 'PEERING'
  | 'SUBNET'
  | 'TRANSIT_GATEWAY';

/** The vendors' source/destination check, as one pass/fail record. */
export interface CloudVnicIpForwardingDecision {
  type: 'cloud vnic ip forwarding';
  vnicId: string;
  direction: 'inbound' | 'outbound';
  /** Source IP for `outbound`, destination IP for `inbound`. */
  ip: string;
  ipMatched: boolean;
  ipForwardingEnabled: boolean;
  passed: boolean;
}

/** Forward to the implicit cloud workload host behind a vNIC. */
export interface CloudVnicWorkloadHandoffDecision {
  type: 'cloud vnic workload handoff';
  vnicId: string;
  destinationIp: string;
}

/** The whole routing step: winning route table, matched prefix, next-hop kind. */
export interface CloudRouteMatchDecision {
  type: 'cloud route match';
  routeTableId: string;
  routeId: string;
  destinationCidr: string;
  nextHopKind: CloudNextHopKind;
  nextHopId?: string;
}

/** Decisions a cloud vNIC records. */
export type CloudVnicDecision =
  | CloudRouteMatchDecision
  | CloudVnicIpForwardingDecision
  | CloudVnicWorkloadHandoffDecision;
